// extracted by mini-css-extract-plugin
export default {"main":"_2ae36c3ae2","tit":"d4d65c4c1f","maintitle":"_00516f466c","ylw":"_40da5cdd89","white":"ef49dde6dd","mv_title":"c9801e8699","mv_nc":"_788cddf428","mv_in":"b07a9c984a"};